import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_3 = {
  class: "alert alert-danger alert-dismissable fade show",
  role: "alert"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close float-end",
  "data-dismiss": "alert",
  "aria-label": "Close",
  onclick: "closeAlert(this)"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "An error was encountered while trying to submit the file. Please try again and/or contact your administrator with the following errors:", -1)
const _hoisted_6 = { class: "list-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tab_layout = _resolveComponent("tab-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.errors && _ctx.errors.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                return (_openBlock(), _createElementBlock("li", null, _toDisplayString(error), 1))
              }), 256))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_tab_layout, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
      tabs: _ctx.tabs,
      "header-left-label": _ctx.headerLeft,
      "header-right-label": _ctx.headerRight,
      onSubmit: _ctx.handleContactsSubmit,
      onUpdateTab: _ctx.handleUpdateTab,
      "cancel-button-url": _ctx.defaultUrl
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeTab), { ref: "tabComponent" }, null, 512))
      ]),
      _: 1
    }, 8, ["modelValue", "tabs", "header-left-label", "header-right-label", "onSubmit", "onUpdateTab", "cancel-button-url"])
  ]))
}